import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ActionButton from '../../../ui/primitives/ActionButton';

const PRIORITY_CONFIG = {
  high: { label: 'High', color: 'error' },
  medium: { label: 'Medium', color: 'warning' },
  low: { label: 'Low', color: 'success' },
};

const AIInsightItem = ({ priority, title, description, recommendation, impact, actionLabel, onActionClick, isLast }) => {
  const priorityConfig = PRIORITY_CONFIG[priority] || PRIORITY_CONFIG.medium;

  return (
    <Box sx={{ display: 'contents' }}>
      <Box sx={{ pt: 2 }}>
        <Chip label={priorityConfig.label} color={priorityConfig.color} size="small" sx={{ fontWeight: 700 }} />
      </Box>

      <Box sx={{ minWidth: 0, pt: 2 }}>
        <Typography variant="subtitle2" fontWeight={600}>
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
          {description}
        </Typography>

        {recommendation && (
        <Box
          sx={(theme) => ({
            mt: 0.75,
            px: 1,
            py: 0.5,
            borderRadius: `${theme.shape.borderRadius}px`,
            bgcolor: alpha(theme.palette.info.main, 0.05),
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
          })}
        >
          <AutoAwesomeIcon sx={{ fontSize: 13, color: 'info.main', flexShrink: 0 }} />
          <Typography variant="caption" color="text.secondary" sx={{ lineHeight: 1.5 }}>
            <Typography component="span" variant="caption" fontWeight={700} color="info.main">
              Recommendation:
            </Typography>{' '}
            {recommendation}
          </Typography>
        </Box>
      )}
      </Box>

      <Box sx={{ minWidth: 0, pt: 2 }}>
        <Typography variant="caption" color="text.secondary" fontWeight={600} display="block">
          Impact
        </Typography>
        <Typography variant="body2" color="text.primary">
          {impact || '—'}
        </Typography>
      </Box>

      <Box
        sx={{
          pt: 2,
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: { xs: 'flex-start', sm: 'flex-end' },
        }}
      >
        {actionLabel && (
          <ActionButton
            label={actionLabel}
            variant="text"
            color="primary"
            endIcon={<ArrowForwardIcon sx={{ fontSize: 16 }} />}
            onClick={onActionClick}
            sx={{ px: 0, whiteSpace: 'nowrap' }}
          />
        )}
      </Box>

      {!isLast && (
        <Box
          sx={{
            gridColumn: '1 / -1',
            borderBottom: '1px solid',
            borderColor: 'divider',
            mt: 2,
          }}
        />
      )}
    </Box>
  );
};

export default AIInsightItem;